import { Alert } from '@amzn/meridian';

const KeywordsVerificationMessage = () => {
  return (
    <Alert title="Keyword Warning" type="neutral">
      I have reviewed and verified the final keyword list for accuracy.
      {/* Update the component to include  */}
    </Alert>
  );
};

export { KeywordsVerificationMessage };
